<template>
  <h3 class="inline-block text-lg font-medium leading-6 text-gray-700">
    <slot />
  </h3>
</template>
